// extracted by mini-css-extract-plugin
module.exports = {"toast":"assistantErrorToast_toast__1X8KB","ask":"assistantErrorToast_ask__ZtI1j"};